import { render, staticRenderFns } from "./expertFee.vue?vue&type=template&id=20f80d02&scoped=true"
import script from "./expertFee.vue?vue&type=script&lang=js"
export * from "./expertFee.vue?vue&type=script&lang=js"
import style0 from "./expertFee.vue?vue&type=style&index=0&id=20f80d02&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f80d02",
  null
  
)

export default component.exports